import { l } from '@manychat/manyui'

import { IEmailTriggerOpenBlock } from 'common/builder/blocks/blockInterfaces'
import { FlowChartNextStepBuilder } from 'common/builder/components/chart/FlowChart/lib/builders/FlowChartNextStepBuilder'
import { FlowChartNextStep } from 'common/builder/components/chart/FlowChart/types/FlowChartNextStep'
import { TriggerOnOpenUse } from 'common/builder/emailBuilder/emailBuilderConstants'
import { IEmailNode } from 'common/builder/nodes/nodeInterfaces'

export const getEmailNodeNextSteps = ({
  node,
  triggerOnOpenBlock,
}: {
  node: IEmailNode
  triggerOnOpenBlock: IEmailTriggerOpenBlock | null
}): FlowChartNextStep[] => {
  const nextSteps: FlowChartNextStep[] = []

  if (node.$isAdditionalAutomation && triggerOnOpenBlock) {
    const triggerOnOpenText =
      triggerOnOpenBlock?.triggerOnOpenUse === TriggerOnOpenUse.FIRST
        ? l.translate('First time contact opens Email')
        : l.translate('Every time contact opens Email')

    nextSteps.push(
      new FlowChartNextStepBuilder(triggerOnOpenBlock.id).withLabel(triggerOnOpenText).build(),
    )
  }

  nextSteps.push(new FlowChartNextStepBuilder(node.id).withLabel(l.translate('Next Step')).build())

  return nextSteps
}
